module.exports = __webpack_public_path__ + "img/yycjbj.941a5d87.png";